import HttpClient from '@/util/http/HttpClient';
import ContentPageRepository from '@/repositories/content/ContentPageRepository';
import CouponRepository from '@/repositories/webshop/CouponRepository';
import FileRepository from '@/repositories/upload/FileRepository';
import ContentPageTranslationRepository from '@/repositories/content/ContentPageTranslationRepository';
import GlobalState from '@/util/GlobalState';
import LabelRepository from '@/repositories/content/label/LabelRepository';
import RowRepository from '@/repositories/content/row/RowRepository';
import RowTranslationRepository from '@/repositories/content/row/RowTranslationRepository';
import RowPageRepository from '@/repositories/content/row/RowPageRepository';
import DirectNavigationItemRepository from '@/repositories/directnavigation/DirectNavigationItemRepository';
import DirectNavigationItemTranslationRepository from '@/repositories/directnavigation/DirectNavigationItemTranslationRepository';
import NavigationItemRepository from '@/repositories/sidebar/NavigationItemRepository';
import NavigationItemTranslationRepository from '@/repositories/sidebar/NavigationItemTranslationRepository';
import SubNavigationItemRepository from '@/repositories/sidebar/SubNavigationItemRepository';
import SubNavigationItemTranslationRepository from '@/repositories/sidebar/SubNavigationItemTranslationRepository';
import WeeklySignRepository from '@/repositories/WeeklySign/WeeklySignRepository';
import WeeklySignTranslationRepository from '@/repositories/WeeklySign/WeeklySignTranslationRepository';
import OrderRepository from '@/repositories/webshop/OrderRepository';
import ProductRepository from '@/repositories/webshop/ProductRepository';
import ProductTranslationRepository from '@/repositories/webshop/ProductTranslationRepository';
import ProductCategoryRepository from '@/repositories/webshop/ProductCategoryRepository';
import ProductOrderRepository from '@/repositories/webshop/ProductOrderRepository';
import LibraryItemRepository from '@/repositories/libraryitem/LibraryItemRepository';
import LibraryItemTranslationRepository from '@/repositories/libraryitem/LibraryItemTranslationRepository';
import ProductImageRepository from '@/repositories/webshop/ProductImageRepository';
import NgtMediaRepository from '@/repositories/NgtMediaRepository';
import ShopHeaderRepository from '@/repositories/content/ShopHeaderRepository';
import FooterRepository from '@/repositories/content/FooterRepository';
import FooterLinkRepository from '@/repositories/content/FooterLinkRepository';
import EmployeeRepository from '@/repositories/employees/EmployeeRepository';
import EmployeeTranslationRepository from '@/repositories/employees/EmployeeTranslationRepository';
import ProductInventoryRepository from '@/repositories/webshop/ProductInventoryRepository';
import AccountViewRepository from '@/repositories/accountview/AccountViewRepository';
import FrontPageContentRepository from '@/repositories/content/FrontPageContentRepository';
import UserRepository from '@/repositories/UserRepository';

const cmsEndpoint = process.env.VUE_APP_API_ENDPOINT;
const loginEndpoint = cmsEndpoint + '/oauth2/authorization/ngc-auth';
const logoutEndpoint = cmsEndpoint + '/oauth2/logout';
const apiEndpoint = cmsEndpoint + '/api';
const httpClient = new HttpClient({});
export const contentPageRepository = new ContentPageRepository(httpClient);
export const couponRepository = new CouponRepository(httpClient);
export const contentPageTranslationRepository = new ContentPageTranslationRepository(httpClient);
export const fileRepository = new FileRepository(httpClient);
export const labelRepository = new LabelRepository(httpClient);
export const frontPageContentRepository = new FrontPageContentRepository(httpClient);
export const rowRepository = new RowRepository(httpClient);
export const rowTranslationRepository = new RowTranslationRepository(httpClient);
export const rowPageRepository = new RowPageRepository(httpClient);
export const directNavigationItemRepository = new DirectNavigationItemRepository(httpClient);
export const directNavigationItemTranslationRepository = new DirectNavigationItemTranslationRepository(httpClient);
export const navigationItemRepository = new NavigationItemRepository(httpClient);
export const navigationItemTranslationRepository = new NavigationItemTranslationRepository(httpClient);
export const subNavigationItemRepository = new SubNavigationItemRepository(httpClient);
export const subNavigationItemTranslationRepository = new SubNavigationItemTranslationRepository(httpClient);
export const weeklySignRepository = new WeeklySignRepository(httpClient);
export const weeklySignTranslationRepository = new WeeklySignTranslationRepository(httpClient);
export const orderRepository = new OrderRepository(httpClient);
export const productRepository = new ProductRepository(httpClient);
export const productTranslationRepository = new ProductTranslationRepository(httpClient);
export const productCategoryRepository = new ProductCategoryRepository(httpClient);
export const productOrderRepository = new ProductOrderRepository(httpClient);
export const productImageRepositroy = new ProductImageRepository(httpClient);
export const productInventoryRepository = new ProductInventoryRepository(httpClient);
export const libraryItemRepository = new LibraryItemRepository(httpClient);
export const libraryItemTranslationRepository = new LibraryItemTranslationRepository(httpClient);
export const ngtMediaRepository = new NgtMediaRepository(httpClient);
export const shopHeaderRepository = new ShopHeaderRepository(httpClient);
export const footerRepository = new FooterRepository(httpClient);
export const footerLinkRepository = new FooterLinkRepository(httpClient);
export const employeeRepository = new EmployeeRepository(httpClient);
export const employeeTranslationRepository = new EmployeeTranslationRepository(httpClient);
export const accountViewRepository = new AccountViewRepository(httpClient);
export const userRepository = new UserRepository(httpClient, apiEndpoint, logoutEndpoint);
export const globalState = new GlobalState(userRepository, loginEndpoint);
